
import Vue from 'vue'

const getDefaultState = () => {
    return {
        toDoCategory: {
            id: 0,
            idProfile: 0,
            description: "",
            mdiIcon: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/toDoCategory/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listToDoCategory = result.data.result;

                return listToDoCategory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list to do list: [${ex}]`
            };
        }
    },

    async ListByProfile() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/toDoCategory/listByProfile",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listToDoCategory = result.data.result;

                return listToDoCategory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list to do list: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/toDoCategory/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get to do list`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get to do list: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, toDoCategoryRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`common/toDoCategory/create-update`, toDoCategoryRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (toDoCategoryRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`common/toDoCategory/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async ListByUser(_, idUser) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/toDoCategory/listByUser/${idUser}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listToDoCategory = result.data.result;

                return listToDoCategory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list to do list: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.toDoCategory, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.toDoCategory;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
